(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Delivery_statusDialogController', Delivery_statusDialogController);

    Delivery_statusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Delivery_status'];

    function Delivery_statusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Delivery_status) {
        var vm = this;

        vm.delivery_status = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.delivery_status.id !== null) {
                Delivery_status.update(vm.delivery_status, onSaveSuccess, onSaveError);
            } else {
                Delivery_status.save(vm.delivery_status, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:delivery_statusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
